import $ from 'jquery';

const scrollTop = () => {
    window.addEventListener('scroll', function(e) {
        if (window.pageYOffset > 400) {
            $('.footer__up').css('display', 'flex')
        } else {
            $('.footer__up').css('display', 'none')
        }
    })

    $('.footer__up').click(function() {
        $("html, body").animate({
            scrollTop: 0
        }, "slow");
        return false;
    })
}

export default scrollTop();

